import { render, staticRenderFns } from "./FileUpload2.vue?vue&type=template&id=3ab13d58&scoped=true&"
import script from "./FileUpload2.vue?vue&type=script&lang=js&"
export * from "./FileUpload2.vue?vue&type=script&lang=js&"
import style0 from "./FileUpload2.vue?vue&type=style&index=0&id=3ab13d58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab13d58",
  null
  
)

export default component.exports